<script>
    import { fly } from "svelte/transition";
    import { Popup, Button } from "../index";
    let show = false;
    let position = "center";
    function handlePop(pos) {
        show = true;
        position = pos;
    }
</script>

<div class="example" transition:fly={{ x: 200 }}>
    <h4 class="example-title">基础用法</h4>
    <div class="example-body">
        <Button block on:click={() => handlePop("center")}>center</Button>
    </div>
    <div class="example-body">
        <Button block on:click={() => handlePop("bottom")} color="primary"
            >bottom</Button
        >
    </div>
    <div class="example-body">
        <Button block on:click={() => handlePop("top")} color="success"
            >top</Button
        >
    </div>
    <div class="example-body">
        <Button block on:click={() => handlePop("left")} color="warning"
            >left</Button
        >
    </div>
    <div class="example-body">
        <Button block on:click={() => handlePop("right")} color="danger"
            >right</Button
        >
    </div>
</div>

<Popup on:close={() => (show = false)} {position} {show}>
    <div class="">
        Consectetur cupidatat anim consectetur Lorem tempor laborum ea aliquip
        ipsum esse dolore. Irure enim adipisicing consequat ullamco proident
        adipisicing consectetur est ex voluptate mollit fugiat enim est quis.
        Aliquip proident mollit sint sit quis cupidatat deserunt dolore tempor
        deserunt voluptate. Voluptate enim velit adipisicing sint elit dolor
        incididunt eiusmod anim do cupidatat nulla elit. Irure cillum ut Lorem
        duis nisi ullamco ex nisi enim mollit. Ex proident sint voluptate sit
        sunt eiusmod amet.
    </div>
</Popup>

<style lang="less">
    @import "./example.less";
</style>
